const pulse = "animate-pulse rounded-xl bg-slate-200 dark:bg-slate-700/80";

const HeaderBlock = () => (
  <div className="flex w-full flex-col items-center gap-3">
    <div className={`h-8 w-2/3 max-w-xl ${pulse}`} />
    <div className={`h-4 w-full max-w-2xl ${pulse}`} />
    <div className={`h-4 w-4/5 max-w-xl ${pulse}`} />
  </div>
);

const VARIANTS = {
  technologies: (
    <section className="layout-shell flex w-full min-h-[8rem]" aria-hidden="true">
      <div className="flex w-full gap-4 overflow-hidden">
        {Array.from({ length: 5 }).map((_, index) => (
          <div key={index} className={`aspect-video w-1/5 min-w-[5rem] flex-shrink-0 ${pulse}`} />
        ))}
      </div>
    </section>
  ),
  features: (
    <section className="layout-shell flex w-full min-h-[28rem] flex-col gap-8" aria-hidden="true">
      <HeaderBlock />
      <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={index} className={`h-32 w-full ${pulse}`} />
        ))}
      </div>
    </section>
  ),
  useCase: (
    <section className="layout-shell flex w-full min-h-[32rem] flex-col gap-6" aria-hidden="true">
      <div className="flex w-full flex-col gap-8 rounded-3xl border border-slate-300 px-4 py-8 dark:border-slate-700 sm:px-8">
        <HeaderBlock />
        <div className="flex w-full flex-col gap-5 lg:flex-row lg:justify-between">
          <div className="flex w-full flex-col gap-3 lg:w-5/12">
            {Array.from({ length: 4 }).map((_, index) => (
              <div key={index} className={`h-14 w-full ${pulse}`} />
            ))}
          </div>
          <div className={`aspect-video w-full lg:w-7/12 ${pulse}`} />
        </div>
      </div>
    </section>
  ),
  impact: (
    <section className="layout-shell flex w-full min-h-[24rem]" aria-hidden="true">
      <div className="flex w-full flex-col items-center gap-8 rounded-3xl border border-orange-500/40 bg-orange-100/50 px-6 py-12 dark:bg-orange-900/20">
        <HeaderBlock />
        <div className="grid w-full grid-cols-2 gap-4 lg:grid-cols-6">
          {Array.from({ length: 6 }).map((_, index) => (
            <div key={index} className={`h-24 w-full ${pulse}`} />
          ))}
        </div>
        <div className={`h-40 w-full max-w-3xl ${pulse}`} />
      </div>
    </section>
  ),
  brands: (
    <section className="layout-shell flex w-full min-h-[20rem] flex-col gap-8" aria-hidden="true">
      <HeaderBlock />
      <div className={`h-24 w-full ${pulse}`} />
      <div className={`h-24 w-full ${pulse}`} />
    </section>
  ),
  certifications: (
    <section className="layout-shell flex w-full min-h-[28rem] flex-col gap-8 rounded-3xl border border-slate-300 p-6 dark:border-slate-700" aria-hidden="true">
      <HeaderBlock />
      <div className="flex w-full flex-col gap-8 md:flex-row">
        <div className={`aspect-[3/4] w-full md:w-1/3 ${pulse}`} />
        <div className="grid w-full grid-cols-3 grid-rows-2 gap-4 md:w-7/12">
          {Array.from({ length: 6 }).map((_, index) => (
            <div key={index} className={`aspect-square w-full ${pulse}`} />
          ))}
        </div>
      </div>
    </section>
  ),
  testimonials: (
    <section className="layout-shell flex w-full min-h-[32rem] flex-col gap-8 rounded-3xl border border-slate-300 p-6 dark:border-slate-700" aria-hidden="true">
      <HeaderBlock />
      <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-3">
        {Array.from({ length: 3 }).map((_, index) => (
          <div key={index} className={`h-48 w-full ${pulse}`} />
        ))}
      </div>
      <div className={`h-56 w-full ${pulse}`} />
    </section>
  ),
  management: (
    <section className="layout-shell flex w-full min-h-[24rem] rounded-xl border border-orange-500/40 px-6 py-12" aria-hidden="true">
      <div className="flex w-full flex-col items-center gap-10">
        <HeaderBlock />
        <div className="flex w-full flex-col gap-8 md:flex-row md:justify-between">
          <div className="grid w-full grid-cols-2 gap-4 md:w-1/2">
            {Array.from({ length: 6 }).map((_, index) => (
              <div key={index} className={`h-16 w-full ${pulse}`} />
            ))}
          </div>
          <div className={`aspect-video w-full md:w-5/12 ${pulse}`} />
        </div>
      </div>
    </section>
  ),
  migration: (
    <section className="flex w-full min-h-[18rem] justify-center py-8" aria-hidden="true">
      <div className="flex w-11/12 flex-wrap items-center justify-between gap-12">
        <div className="flex w-full flex-col gap-4 md:w-5/12">
          <div className={`h-10 w-4/5 ${pulse}`} />
          {Array.from({ length: 3 }).map((_, index) => (
            <div key={index} className={`h-4 w-full ${pulse}`} />
          ))}
        </div>
        <div className={`aspect-video w-full md:w-1/2 ${pulse}`} />
      </div>
    </section>
  ),
  cta: (
    <section className="layout-shell flex w-full min-h-[12rem]" aria-hidden="true">
      <div className={`flex h-full w-full flex-col gap-4 rounded-3xl px-8 py-10 lg:flex-row lg:items-center lg:justify-between ${pulse}`}>
        <div className="flex w-full max-w-3xl flex-col gap-3">
          <div className={`h-8 w-3/4 ${pulse}`} />
          <div className={`h-4 w-full ${pulse}`} />
        </div>
        <div className={`h-12 w-40 ${pulse}`} />
      </div>
    </section>
  ),
  faq: (
    <section className="layout-shell flex w-full min-h-[24rem] flex-col gap-8" aria-hidden="true">
      <HeaderBlock />
      <div className="flex w-full flex-col gap-4 lg:flex-row">
        {Array.from({ length: 2 }).map((_, columnIndex) => (
          <div key={columnIndex} className="flex flex-1 flex-col gap-4">
            {Array.from({ length: 4 }).map((_, index) => (
              <div key={index} className={`h-20 w-full ${pulse}`} />
            ))}
          </div>
        ))}
      </div>
    </section>
  ),
  calculator: (
    <section className="layout-shell flex w-full min-h-[32rem] flex-col gap-8" aria-hidden="true">
      <HeaderBlock />
      <div className={`h-56 w-full ${pulse}`} />
      <div className="grid w-full grid-cols-2 gap-4 md:grid-cols-4">
        {Array.from({ length: 4 }).map((_, index) => (
          <div key={index} className={`h-24 w-full ${pulse}`} />
        ))}
      </div>
    </section>
  ),
  compare: (
    <section className="layout-shell flex w-full min-h-[36rem] flex-col gap-8" aria-hidden="true">
      <HeaderBlock />
      <div className={`h-12 w-full ${pulse}`} />
      {Array.from({ length: 6 }).map((_, index) => (
        <div key={index} className={`h-16 w-full ${pulse}`} />
      ))}
    </section>
  ),
  image: (
    <section className="layout-shell flex w-full min-h-[28rem] w-11/12" aria-hidden="true">
      <div className={`h-[450px] w-full ${pulse}`} />
    </section>
  ),
  prose: (
    <section className="layout-shell flex w-11/12 w-full min-h-[40rem] flex-col gap-4 py-8" aria-hidden="true">
      {Array.from({ length: 10 }).map((_, index) => (
        <div key={index} className={`h-4 w-full ${index % 3 === 0 ? "w-4/5" : "w-full"} ${pulse}`} />
      ))}
    </section>
  ),
  content: (
    <section className="flex w-7/12 min-h-[32rem] flex-col gap-8" aria-hidden="true">
      <div className={`h-8 w-2/3 ${pulse}`} />
      <div className={`h-4 w-1/3 ${pulse}`} />
      <div className={`aspect-video w-full ${pulse}`} />
      {Array.from({ length: 6 }).map((_, index) => (
        <div key={index} className={`h-4 w-full ${pulse}`} />
      ))}
    </section>
  ),
  form: (
    <section className="flex w-11/12 min-h-[28rem] w-full flex-col gap-8 md:flex-row" aria-hidden="true">
      <div className="flex w-full flex-col gap-4 md:w-5/12">
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={index} className={`h-4 w-full ${pulse}`} />
        ))}
      </div>
      <div className={`h-[450px] w-full md:w-5/6 ${pulse}`} />
    </section>
  ),
  sitemap: (
    <section className="grid w-11/12 min-h-[20rem] grid-cols-1 gap-6 py-8 sm:grid-cols-3 lg:grid-cols-4" aria-hidden="true">
      {Array.from({ length: 8 }).map((_, index) => (
        <div key={index} className={`h-32 w-full ${pulse}`} />
      ))}
    </section>
  ),
  services: (
    <section className="layout-shell flex w-full min-h-[24rem] flex-col gap-8" aria-hidden="true">
      <HeaderBlock />
      <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-2">
        {Array.from({ length: 4 }).map((_, index) => (
          <div key={index} className={`h-28 w-full ${pulse}`} />
        ))}
      </div>
    </section>
  ),
  location: (
    <section className="layout-shell flex w-full min-h-[24rem] flex-col gap-6" aria-hidden="true">
      <HeaderBlock />
      <div className={`aspect-video w-full ${pulse}`} />
    </section>
  ),
  apps: (
    <section className="layout-shell flex w-full min-h-[20rem] flex-col gap-6" aria-hidden="true">
      <HeaderBlock />
      <div className="grid w-full grid-cols-2 gap-4 md:grid-cols-4">
        {Array.from({ length: 8 }).map((_, index) => (
          <div key={index} className={`h-20 w-full ${pulse}`} />
        ))}
      </div>
    </section>
  ),
  tco: (
    <section className="layout-shell flex w-full min-h-[28rem] flex-col gap-8" aria-hidden="true">
      <HeaderBlock />
      <div className={`h-48 w-full ${pulse}`} />
    </section>
  ),
  carousel: (
    <section className="layout-shell flex w-full min-h-[10rem]" aria-hidden="true">
      <div className={`h-28 w-full ${pulse}`} />
    </section>
  ),
};

const SectionSkeletons = ({ variant = "useCase" }) => VARIANTS[variant] ?? VARIANTS.useCase;

export default SectionSkeletons;